import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import TaxAssistant from "./TaxAssistant";

const PAGE_TITLES = {
  "/dashboard": "Dashboard",
  "/documents": "My Documents",
  "/upload": "Upload Document",
  "/profile": "My Profile",
  "/tax-returns": "Tax Returns",
  "/settings": "Settings",
  "/notifications": "Notifications",
  "/tax-calendar":  "Tax Calendar",
  "/sars":          "SARS Submissions",
  "/calculator":    "Tax Calculator",
  "/budget":        "Budget Planner",
  "/pricing":       "Plans & Pricing",
  "/credit-debt":   "Credit & Debt Tracker",
  "/investments":   "Investment Portfolio",
  "/analytics":     "Analytics & Insights",
};

export default function Layout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const pageTitle = PAGE_TITLES[location.pathname] || "TaxVault";

  return (
    <div className="flex h-screen overflow-hidden bg-luxury-bg">
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />

      {/* Main content */}
      <div className="flex flex-col flex-1 overflow-hidden lg:ml-64">

        {/* Top bar — iOS liquid glass */}
        <header className="flex-shrink-0 flex items-center justify-between px-6 py-3.5 border-b border-white/[0.06] glass-strong sticky top-0 z-10">

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(true)}
            className="lg:hidden p-2 rounded-xl mr-3 text-luxury-secondary hover:text-luxury-gold hover:glass-thin transition-all"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>

          <div>
            <h1 className="text-base font-bold text-luxury-text tracking-tight">{pageTitle}</h1>
            <p className="text-xs text-luxury-muted">TaxVault Global · South Africa</p>
          </div>

          <div className="flex items-center gap-2.5 ml-auto">

            {/* Notification bell */}
            <button
              onClick={() => navigate("/notifications")}
              className={`relative p-2.5 rounded-xl transition-all duration-200
                ${location.pathname === "/notifications"
                  ? "glass-gold text-luxury-gold"
                  : "text-luxury-secondary hover:text-luxury-gold hover:glass-thin"
                }`}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
              {location.pathname !== "/notifications" && (
                <span className="absolute top-2 right-2 w-2 h-2 bg-luxury-cta rounded-full animate-pulse shadow-sm shadow-luxury-cta/50" />
              )}
            </button>

            {/* Live status pill */}
            <div className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold glass text-luxury-secondary">
              <span className="w-1.5 h-1.5 bg-luxury-cta rounded-full animate-pulse" />
              Live
            </div>
          </div>
        </header>

        {/* Page content */}
        <main className="flex-1 overflow-y-auto bg-luxury-bg">
          {children}
        </main>
      </div>

      {/* AI Tax Assistant — available on every page */}
      <TaxAssistant />
    </div>
  );
}
